<template>
	<div>
		<div ref="modalSession" 
			class="modal fade" :class="{ show: active, 'd-block': active }"
			tabindex="-1" role="dialog">
			<div class="modal-dialog modal-dialog-centered modal-lg" 
				role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">
							{{ $t('default.session.modal.title') }}
						</h5>
						<button
							type="button"
							class="close btn-lg"
							data-dismiss="modal"
							aria-label="Close"
							@click="modalToggle">
							<span aria-hidden="true" style="color:red;">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<b-container>
							<h5 v-if="this.$store.getters.loggedIn">
								{{$t('default.session.modal.message', { modalTime: convertTime}) }}
							</h5>
							<h5 v-else>
								Vous avez été déconnecté après une longue période d'inactivité
							</h5>
						</b-container>
					</div>
					<div class="modal-footer">
						
						<b-button class="btn btn-dark btn-sm" 
							@click="modalToggle">
							<fa icon="times"/>
							{{ $t("default.button.close") }}
						</b-button>
						<button type="button" class="btn-sm btn-success" @click="this.modalToggle(); this.$store.dispatch('auth');">
							<fa icon="sign-in"/> {{ $t('topnav.login', 1) }}
						</button>
						<!-- <b-button v-if="this.$store.getters.loggedIn" class="btn btn-success btn-sm" @click="refreshSession()">
							<fa icon="refresh" />
							{{$t('default.session.modal.refresh')}}
						</b-button> -->
						
					</div>

				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: "modal-session",
		props: ['modalTime'],
		data() {
			return {
				active: false,
				modalTimeLocal: this.modalTime,
				modalCancelIntervalValue: null,				
			}
		},
		computed: {
			convertTime(){
				let minute = Math.floor(this.modalTimeLocal / 60);
				let second = this.modalTimeLocal % 60
				let time = (minute > 0 ? minute.toString().padStart(2, "0") + " minute(s) " : '') + (second.toString().padStart(2, "0") + " seconde(s)")
				return time
			},
			
		},
		methods:{
			modalToggle() {
				if(this.active){
					this.active = false
					// on desactive le compteur 
					clearInterval(this.modalCancelIntervalValue)
					this.modalCancelIntervalValue = null
				}
				else{
					this.active = true
					this.startTimer()
				}
			},
			startTimer() {
				var that = this;
				isNaN(that.modalTimeLocal) ? that.modalTimeLocal = 0 : that.modalTimeLocal
				that.modalCancelIntervalValue = setInterval(function () {
					if(that.modalTimeLocal > 0) that.modalTimeLocal--
					else {
						clearInterval(that.modalCancelIntervalValue)
						that.modalCancelIntervalValue = null
						// after logout session
						console.log("deconnexion")
						this.active = false
						this.$store?.dispatch('logout').then(response => {})
						// this.$nextTick(function () {
							// this?.autoLogout();
						// });
					}
				}, 1000);
			},
			async refreshSession() {
				await this.$store.dispatch('refreshToken').then(response => {
					this.$nextTick(function () {
						this.modalToggle()
						console.log('refreshing')
					});
				});
			},
			autoLogout(){
				// console.log('autoLogout')
				this.$store?.dispatch('logout')
				.then(response => {
					// console.log('Timeout session')
				})
				.catch(err => {
					if (err.name !== 'NavigationDuplicated' && !err.message.includes('Avoided redundant navigation to current location'))
					console.log(err);
				})
			}
		}

	}
</script>